export const SERVER_MAP = {
  TREASURE_FINDER:
    "us-central1-treasure-finder-62cd0.cloudfunctions.net/treasure-finder-be",
};
